import ChessGridPromises from './ChessGridPromises';

export default ChessGridPromises;
